// extracted by mini-css-extract-plugin
export default {"root":"ShadowWrapper_root__b5Wp0"};